import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import RouteMap from "../components/RouteMap";
import Footer from "../components/Footer";
import { updateSEO, buildBreadcrumbSchema } from "../utils/seo";

/**
 * Standalone sub-page that hosts the "Smart Transportation Dashboard"
 * (RouteMap) preview. Same component as on Home — adds top padding
 * so the fixed Navbar doesn't overlap the dashboard.
 */
const TransportDashboard: React.FC = () => {
  useEffect(() => {
    updateSEO({
      title: "Smart Transportation Dashboard — Live Campus Route Map",
      description:
        "Preview SaferSavvy's interactive smart transportation dashboard. View real-time campus bus routes, live tracking, and AI-optimized transport schedules on an interactive map.",
      canonical: "/transport-dashboard",
      keywords:
        "transport dashboard, campus route map, live bus tracking, smart transportation, SaferSavvy dashboard, university transport automation",
      jsonLd: buildBreadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Transport Dashboard", url: "/transport-dashboard" },
      ]),
    });
  }, []);

  return (
    <div className="font-sans text-gray-800 dark:text-ink-100 dark:bg-ink-850 overflow-x-hidden min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 sm:pt-28">
        <RouteMap />
      </main>
      <Footer />
    </div>
  );
};

export default TransportDashboard;
